import { Box } from 'src/components/Box';
import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';

import { ActionsList } from './ActionsList';
import { BlockingReasonList } from './BlockingReasonList';
import { BookingSessionDetails } from './BookingSessionDetails';
import { CheckinBlockerSessionDetails, CheckinBlockerUser } from './_types';

export function SessionContent({
  users,
  actions,
  getBlockerActions,
  sessionDetails,
  fillAvailableSpace = false,
}: {
  users: CheckinBlockerUser[];
  actions?: ButtonPropsWithLabel[];
  getBlockerActions?: (
    user: CheckinBlockerUser,
    blocker: CheckinBlockerUser['blockers'][number],
    index: number
  ) => ButtonPropsWithLabel[] | undefined;
  sessionDetails: CheckinBlockerSessionDetails;
  fillAvailableSpace?: boolean;
}) {
  return (
    <Stack
      spacing={3}
      sx={{
        width: '100%',
        ...(fillAvailableSpace && {
          flex: 1,
          minHeight: 0,
          justifyContent: 'space-between',
        }),
      }}
    >
      {users.map((user, index) => (
        <Stack
          key={
            user.id != null && user.id !== ''
              ? user.id
              : `checkin-blocker-${index}`
          }
          spacing={2}
          sx={{ width: '100%' }}
        >
          <BlockingReasonList
            blockers={user.blockers}
            getBlockerActions={(blocker, index) =>
              getBlockerActions?.(user, blocker, index)
            }
            userId={user.id ?? ''}
            variant="booking"
          />
        </Stack>
      ))}

      <BookingSessionDetails sessionDetails={sessionDetails} />

      {!!actions && (
        <Box sx={fillAvailableSpace ? { mt: 'auto', pt: 1 } : undefined}>
          <ActionsList actions={actions} />
        </Box>
      )}
    </Stack>
  );
}
